import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import parse from "html-react-parser"
import "./blockTextMoreGeneric.scss"
import Title from "../../common/title"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useIntl } from "gatsby-plugin-react-intl"
import { Spoiler } from "@mantine/core"

const BlockTextMoreGeneric = ({ content }) => {
  const intl = useIntl()

  const listItems = content.relationships.block_grid_items.map(
    (list, index) => (
      <Col key={index} md={6} xs={12} className="blk-text-more-content">
        <div className="sectionImage">
          {list.relationships.grid_item_media && (
            <GatsbyImage
              image={getImage(
                list.relationships.grid_item_media.relationships.field_image
                  .gatsbyImage
              )}
              height="auto"
            />
          )}
        </div>
        <Title heading={2} size={2} text={list.grid_item_title} />

        <Spoiler
          /* Default options */
          maxHeight={71}
          showLabel={intl.formatMessage({ id: "generic-page.read_more" })}
          hideLabel={intl.formatMessage({ id: "generic-page.close" })}
          className="content-css"
        >
          <div className="description">
            {parse(list.grid_item_description.processed)}
          </div>
          {list.grid_item_link && (
            <a className="simpleLink" href={list.grid_item_link.url}>
              {list.grid_item_link.title}
            </a>
          )}
        </Spoiler>
      </Col>
    )
  )

  return (
    <section className="blk-text-more-generic blk-spacing">
      <Container>
        <Row>{listItems}</Row>
      </Container>
    </section>
  )
}

export default BlockTextMoreGeneric
